var _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
export var StyledButton = styled.button(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      '\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 3.625rem;\n  height: 3.125rem;\n  background-color: #ccc;\n  border: none;\n  border-top-right-radius: 0.225rem;\n  cursor: pointer;\n\n  &::after,\n  &::before {\n    content: "";\n    position: absolute;\n    display: block;\n\n    width: 1.5rem;\n    height: 0.125rem;\n    background-color: #5e5e5e;\n    border-radius: 0.125rem;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  &::before {\n    transform: translate(-50%, -50%) rotate(45deg);\n  }\n\n  &::after {\n    transform: translate(-50%, -50%) rotate(-45deg);\n  }\n',
    ]))
);
export var StyledWrapper = styled.div(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteralLoose([
      "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding-top: 3rem;\n  border-radius: 0.625rem;\n\n  overflow-y: scroll;\n  scrollbar-color: transparent transparent;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n  }\n",
    ]))
);
export var StyledTopRow = styled.div(
  _templateObject3 ||
    (_templateObject3 = _taggedTemplateLiteralLoose([
      "\n  padding: 1.5rem;\n  border-top-right-radius: 0.625rem;\n  border-top-left-radius: 0.625rem;\n",
    ]))
);
export var StyledTopBorder = styled.div(
  _templateObject4 ||
    (_templateObject4 = _taggedTemplateLiteralLoose([
      "\n  display: flex;\n  align-items: flex-start;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid #323232;\n",
    ]))
);
export var StyledTitleWrap = styled.div(
  _templateObject5 ||
    (_templateObject5 = _taggedTemplateLiteralLoose([
      "\n  padding-right: 1rem;\n  margin-right: 1rem;\n  margin-left: 0.2rem;\n",
    ]))
);
export var StyledTitle = styled.h2(
  _templateObject6 ||
    (_templateObject6 = _taggedTemplateLiteralLoose([
      '\n  font-size: 1.5rem;\n  text-transform: uppercase;\n  position: relative;\n\n  &::after {\n    content: "";\n    position: absolute;\n    display: block;\n    top: 0;\n    width: 1px;\n    height: 100%;\n    background-color: black;\n    left: auto;\n    right: -1rem;\n  }\n',
    ]))
);
export var StyledLinkWrapper = styled.a(
  _templateObject7 ||
    (_templateObject7 = _taggedTemplateLiteralLoose([
      "\n  font-size: 0.875rem;\n  color: rgba(240, 12, 245, 0.5);\n  max-width: 15rem;\n\n  &:hover {\n    color: rgba(240, 12, 245, 1);\n  }\n",
    ]))
);
export var StyledParagraph = styled.p(
  _templateObject8 ||
    (_templateObject8 = _taggedTemplateLiteralLoose([
      "\n  font-size: 1.5rem;\n  text-transform: uppercase;\n  margin-right: 5rem;\n",
    ]))
);
export var StyledMainContent = styled.div(
  _templateObject9 ||
    (_templateObject9 = _taggedTemplateLiteralLoose([
      "\n  padding: 1.5rem;\n  padding-bottom: 2.5rem;\n",
    ]))
);
export var StyledMainTitle = styled.h3(
  _templateObject10 ||
    (_templateObject10 = _taggedTemplateLiteralLoose([
      "\n  margin-bottom: 2rem;\n  font-size: 1.75rem;\n",
    ]))
);
